document.addEventListener('DOMContentLoaded', function () {
    // Encontra todos os contêineres de acordeão na página
    const accordionGroups = document.querySelectorAll('.wpmundi-accordion-group');

    accordionGroups.forEach((group) => {
        // Pega todos os elementos <details> DENTRO do nosso grupo
        // (agora eles podem estar aninhados dentro de um core/group)
        const detailsElements = group.querySelectorAll('details');

        detailsElements.forEach((currentDetails) => {
            // Adiciona um ouvinte de evento para o 'toggle' (abrir/fechar)
            currentDetails.addEventListener('toggle', (event) => {
                // Se o item atual foi aberto (e não fechado), então prossiga.
                if (currentDetails.open) {
                    // Percorre todos os outros itens no mesmo grupo
                    detailsElements.forEach((otherDetails) => {
                        // Se o 'outro item' não for o 'item atual'...
                        if (otherDetails !== currentDetails) {
                            // ...força ele a fechar.
                            otherDetails.open = false;
                        }
                    });
                }
            });
        });
    });
});